import request from '@/util/request';

/**
 * 登录
 * @param {phone,uuid,password} data
 */
export function enterpriseLogo() {
  return request({
    url: `/api/v1/account/enterprise/logo`,
    method: 'GET',
  })
}


